import Button from '../../Button'
import { NOTIFICATION_BUTTON_DEFAULT_HEIGHT } from '../Notification.constants'

function NotificationTextButton({
  beforeIconProps,
  className,
  isLoading,
  text,
  onClick,
}) {
  return (
    <Button.Text
      beforeIconProps={beforeIconProps}
      className={className}
      height={NOTIFICATION_BUTTON_DEFAULT_HEIGHT}
      isLoading={isLoading}
      text={text}
      type='button'
      onClick={onClick}
    />
  )
}

export default NotificationTextButton
